import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {push} from 'react-router-redux';
import {createSelector} from 'reselect';

import * as styles from '../../styles';
import PaginatedContainer from '../../paginator/paginated_container';
import filtersSelectorGenerator from '../schools/filters';


export default class ExaminationSchools extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        user: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    style = {items: {itemsList: {width: 'auto', overflowX: 'auto'}}}

    listFieldsSelector = createSelector(
        [
            () => this.context.user.id,
            () => this.props.type,
        ],
        () => [
            ...this.context.user.hasPerm('examination.reports')
                ? [{field: 'id', label: window.gettext('ID')}]
                : [],
            {field: 'name', label: window.gettext('Name')},
            {field: item => _.map(item.levels, level => level.title).join(window.gettext(',') + ' '), label: window.gettext('Level')},
            ...this.context.user.hasPerm('school.get')
                ? [
                    {field: item => item.city ? item.city.name : '-' , label: window.gettext('City')},
                    {field: item => item.city ? item.city.region_display : '-', label: window.gettext('Region')},
                    {field: item => item.gender === 1 ? window.gettext('Male') : window.gettext('Female'), label: window.gettext('Gender')},
                ]
                : [],
            ...this.props.type === 1
                ? [
                    {
                        field: 'registered',
                        label: window.gettext('Registered'),
                    },
                    {
                        field: 'read_papers',
                        label: window.gettext('Read Papers'),
                    },
                    ...this.context.user.hasPerm('examination.analyze')
                        ? [
                            {
                                field: item => <div
                                    style={{
                                        backgroundColor: item.base_analyze === item.read_papers
                                            ? styles.successBackColor
                                            : item.base_analyze === 0
                                                ? styles.warningBackColor
                                                : undefined,
                                        color: item.base_analyze === item.read_papers
                                            ? styles.successColor
                                            : item.base_analyze === 0
                                                ? styles.warningColor
                                                : undefined,
                                        borderColor: item.base_analyze === item.read_papers
                                            ? styles.successBorderColor
                                            : item.base_analyze === 0
                                                ? styles.warningBorderColor
                                                : undefined,
                                        textAlign: 'center',
                                    }}>
                                    {item.read_papers === 0
                                        ? ''
                                        : item.base_analyze === item.read_papers
                                            ? window.gettext('Base Analyze') 
                                            : item.base_analyze === 0
                                                ? window.gettext('Second Analyze')
                                                : <span>
                                                    <span
                                                        style={{
                                                            backgroundColor: styles.successBackColor,
                                                            color: styles.successColor,
                                                            borderColor: styles.successBorderColor,
                                                            padding: '.5em',
                                                        }}>
                                                        {item.base_analyze.persian()}
                                                    </span>
                                                    &nbsp;-&nbsp;
                                                    <span
                                                        style={{
                                                            backgroundColor: styles.warningBackColor,
                                                            color: styles.warningColor,
                                                            borderColor: styles.warningBorderColor,
                                                            padding: '.5em',
                                                        }}>
                                                        {(item.read_papers - item.base_analyze).persian()}
                                                    </span>
                                                </span>
                                    }
                                </div>,
                                label: window.gettext('Base Analyze'),
                            },
                        ]
                        : [],
                    {
                        field: item => item.read_papers > 0
                            ? <button
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.context.store.dispatch(push(
                                        this.context.store.getState().getIn(
                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                        ) + item.id + '/',
                                    ));
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {window.gettext('Report')}
                            </button>
                            : null,
                    },
                ]
                : [
                    {
                        field: item => window.pgettext('examination', 'Status-' + ( () => {
                            if (item.marked_students === 1)
                                return 8;
                            else if (item.read_papers > 0)
                                return 7;
                            else
                                return 2;
                        })()),
                        label: window.gettext('Status'),
                    },
                    {
                        field: item => `${item.read_papers} ${window.gettext('from')} ${item.pages}`.persian(),
                        label: window.gettext('Read Papers'),
                        style: item => item.read_papers > 0 && item.read_papers < item.pages
                            ? {
                                backgroundColor: styles.alertBackColor,
                                color: styles.alertColor,
                            }
                            : item.read_papers === item.pages
                                ? {
                                    backgroundColor: styles.successBackColor,
                                    color: styles.successColor,
                                }
                                : {},
                    },
                    {
                        field: item => `${item.marked_questions} ${window.gettext('from')} ${item.questions}`,
                        label: window.gettext('Marked Questions'),
                    },
                    {
                        style: {width: '1px'},
                        field: item => item.read_papers > 0 || item.published_key
                            ? <button
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.context.store.dispatch(push(
                                        this.context.store.getState().getIn(
                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                        ) + item.id + '/paper/',
                                    ));
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {item.read_papers > 0
                                    ? window.gettext('Paper')
                                    : window.gettext('Key')
                                }
                            </button>
                            : null,
                        label: window.gettext('Paper') + '/' + window.gettext('Key'),
                    },
                    {
                        style: {width: '1px'},
                        field: item => item.marked_students
                            ? <button
                                style={{
                                    ...styles.button,
                                    backgroundColor: 'transparent',
                                    padding: '.25em',
                                    boxSizing: 'border-box',
                                }}
                                onClick={event => {
                                    event.stopPropagation();
                                    this.context.store.dispatch(push(
                                        this.context.store.getState().getIn(
                                            ['routing', 'locationBeforeTransitions', 'pathname'],
                                        ) + item.id + '/report/',
                                    ));
                                }}
                                onMouseUp={({target}) => target.blur()}>
                                {window.gettext('Report')}
                            </button>
                            : null,
                        label: window.gettext('Report'),
                    },
                ],
        ],
    )

    studentsFiltersSelector = this.filtersSelectorGenerator.bind(this)()
    filtersSelector = createSelector.bind(this)(
        [store => this.studentsFiltersSelector(store)],
        studentsFilters => [
            {
                field: 'examination',
                selected: {[this.props.params.examinationId]: null},
            },
            ...studentsFilters,
        ]
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
        {name: 'name', label: window.gettext('Name')},
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0 && this.context.user.hasPerm('examination.analyze')
                    ? []
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.buttonActions,
        ],
        () => _.concat(
            [
                {
                    label: window.gettext('Back'),
                    action: () => this.context.store.dispatch(push(this.props.urls.back.format(this.props.params))),
                },
            ],
            this.props.buttonActions,
        ),
    )

    render() {
        return <span>
            <span style={{display: this.props.children ? 'none' : undefined}}>
                <PaginatedContainer
                    store={this.props.store.get('paginator')}
                    resource='school'
                    style={this.style}
                    listFields={this.listFieldsSelector(this.props.store)}
                    tooltip={null}
                    title={window.gettext('Schools')}
                    selectable
                    events={{onClick: () => null}}
                    filters={this.filtersSelector(this.props.store)}
                    sorts={this.sorts}
                    pageSize={this.props.pageSize}
                    actions={this.actionsSelector(this.props.store)}
                    buttonActions={this.buttonActionsSelector(this.props.store)}
                />
            </span>
            {this.props.children}
        </span>;
    }
}
